export default "__VITE_ASSET__Betcql5D__"